<template>
  <el-form
    class="auditModel"
    ref="formRef"
    :model="formData"
    :rules="rules"
    size="small"
    label-width="130px"
    label-suffix="："
  >
    <el-form-item label="扣款流水号" prop="id">
      {{ detailData.id }}
    </el-form-item>
    <el-form-item label="结算模式" prop="settlementModel">
      {{ detailData.settlementModel }}
    </el-form-item>
    <el-form-item label="公司名称" prop="companyName">
      {{ detailData.companyName }}
    </el-form-item>
    <el-form-item label="应用名称" prop="appName">
      {{ detailData.appName }}
    </el-form-item>
    <el-form-item label="扣款金额($)" prop="amount">
      {{ detailData.amount | numberFilter }}
    </el-form-item>
    <el-form-item label="备注" prop="remark">
      {{ detailData.remark }}
    </el-form-item>
    <el-form-item label="结算数据" prop="settlementData">
      <div class="upFc">
        <div class="imgFile">
          <el-image
            :preview-teleported="true"
            class="image"
            v-for="(url, index) in imgChangeType(imgUrlList)"
            :key="index"
            :src="url"
            :preview-src-list="imgChangeType(imgUrlList)"
          >
          </el-image>
          <div
            class="file-item"
            v-for="(url, index) in pdfChangeType(imgUrlList)"
            :key="index"
            @click="lokinfoPDf(url)"
          >
            <img
              class="image"
              src="../../../../assets/images/excel.png"
              alt=""
            />
            <!-- 新增的显示文件名的 span -->
            <span class="file-name">{{ getFileName(url) }}</span>
            <!-- <i
              class="el-icon-close cursor ml10"
              @click="handleRemoveFile(index)"
            ></i> -->
          </div>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="审核结果" prop="status">
      <el-radio-group
        :disabled="detailData.reviewsStatus != 1"
        v-model="formData.status"
        @change="$refs.formRef.clearValidate()"
      >
        <el-radio :label="2">通过</el-radio>
        <el-radio :label="3">不通过</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item
      label="审核意见"
      prop="reviewContent"
      v-if="formData.status == 3"
      :rules="[
        {
          required: formData.status == 3 ? true : false,
          message: '请输入审核意见',
        },
      ]"
    >
      <el-input
        :disabled="detailData.reviewsStatus != 1"
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 6 }"
        show-word-limit
        maxlength="100"
        v-model="formData.reviewContent"
        suffix-icon="el-icon-date"
        autocomplete="off"
      ></el-input>
    </el-form-item>
    <div class="disfr jc ac" v-if="detailData.reviewsStatus == 1">
      <el-button size="small" type="primary" @click="handleSubmitAudit"
        >提交</el-button
      >
    </div>
  </el-form>
</template>
<script>
import UploadFile from "@/components/UploadFile1.vue";
import { sendMail } from "./indexServe";
export default {
  components: { UploadFile },
  props: {
    detailData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      checked: false,
      imgUrlList: JSON.parse(this.detailData.settlementData),
      formData: { status: 0, fileName: "" },
      rules: {
        status: [{ required: true, message: "请选择审核结果" }],
        fileName: [{ required: true, message: "请上传收款凭证" }],
      },
    };
  },
  watch: {
    detailData: {
      deep: true,
      handler(newVal) {
        this.resetData(newVal); // 监听变化，重置数据
      },
    },
  },
  mounted() {
    this.resetData(this.detailData);
  },
  computed: {},
  methods: {
    resetData(newDetail) {
      // 重置图片列表
      this.imgUrlList = newDetail.settlementData
        ? JSON.parse(newDetail.settlementData)
        : [];

      // 重置表单数据
      this.formData = { status: 1, reviewContent: "", fileName: "" };

      // 根据新的 detailData 更新状态
      if (newDetail.reviewsStatus !== 1) {
        this.formData.status = newDetail.reviewsStatus;
        this.formData.reviewContent = newDetail.reviewContent || "";
      }

      // 其他方法...
    },
    getFileName(url) {
      if (url) {
        const arr = url.split("/"); // 按路径分隔，若 url 是纯文件名则可省略，根据实际情况调整
        return arr[arr.length - 1];
      } else {
        return "";
      }
    },
    lokinfoPDf(url) {
      window.open(url, "_blank");
    },
    imgChangeType(arr) {
      let arrayData = [];

      try {
        // 情况1：如果是字符串，尝试解析为JSON数组
        if (typeof arr === "string") {
          // 去除可能存在的前后空格（避免解析失败）
          const trimmedStr = arr.trim();
          // 只有看起来像数组的字符串才尝试解析
          if (trimmedStr.startsWith("[") && trimmedStr.endsWith("]")) {
            arrayData = JSON.parse(trimmedStr);
          } else {
            // 不像数组的字符串，直接包装成数组
            arrayData = [trimmedStr];
          }
        }
        // 情况2：如果已经是数组，直接使用
        else if (Array.isArray(arr)) {
          arrayData = arr;
        }
        // 情况3：其他类型，包装成数组
        else {
          arrayData = [arr];
        }

        // 确保最终是数组（防止解析失败）
        if (!Array.isArray(arrayData)) {
          arrayData = [arr];
        }

        // 筛选xls和xlsx文件
        return arrayData.filter((element) => {
          return (
            typeof element === "string" &&
            (element.endsWith(".jpg") || element.endsWith(".png"))
          );
        });
      } catch (e) {
        console.error("解析数据出错:", e);
        return []; // 出错时返回空数组，避免崩溃
      }
    },
    pdfChangeType(arr) {
      let arrayData = [];

      try {
        // 情况1：如果是字符串，尝试解析为JSON数组
        if (typeof arr === "string") {
          // 去除可能存在的前后空格（避免解析失败）
          const trimmedStr = arr.trim();
          // 只有看起来像数组的字符串才尝试解析
          if (trimmedStr.startsWith("[") && trimmedStr.endsWith("]")) {
            arrayData = JSON.parse(trimmedStr);
          } else {
            // 不像数组的字符串，直接包装成数组
            arrayData = [trimmedStr];
          }
        }
        // 情况2：如果已经是数组，直接使用
        else if (Array.isArray(arr)) {
          arrayData = arr;
        }
        // 情况3：其他类型，包装成数组
        else {
          arrayData = [arr];
        }

        // 确保最终是数组（防止解析失败）
        if (!Array.isArray(arrayData)) {
          arrayData = [arr];
        }

        // 筛选xls和xlsx文件
        return arrayData.filter((element) => {
          return (
            typeof element === "string" &&
            (element.endsWith(".xls") || element.endsWith(".xlsx"))
          );
        });
      } catch (e) {
        console.error("解析数据出错:", e);
        return []; // 出错时返回空数组，避免崩溃
      }
      // let arrAy = arr.split(",");
      // if (arr && arr.length > 0) {
      //   return arr.filter((element) =>
      //     element.endsWith(".pdf" || ".xlsx" || ".xls")
      //   );
      // } else {
      //   return "";
      // }
    },

    handleSubmitAudit() {
      this.$refs.formRef.validate((valid) => {
        let uploadValid = true;
        if (this.$refs.uploadRef) {
          uploadValid = this.$refs.uploadRef.getValidate();
        }
        if (valid && uploadValid) {
          const { status, reviewContent } = this.formData;
          const data = {
            id: this.detailData.id,
            status,
            reviewContent: this.formData.reviewContent,
          };
          if (status == 2) {
            // 审核通过需要收款凭据
          } else {
            // 审核不通过需要审核理由
            data.reviewContent = reviewContent;
          }
          this.$emit("submit", data);
        }
      });
    },
    uploadSuccess(file) {
      this.formData.accessFilePath = file.accessPath;
      this.formData.accessFileId = file.fileId;
      this.formData.fileName = file.fileName;
      this.$refs.formRef.clearValidate("fileName");
    },
    handleRemoveFile() {
      this.formData.accessFilePath = "";
      this.formData.accessFileId = "";
      this.formData.fileName = "";
    },
  },
};
</script>

<style lang="scss">
.file-name {
  // white-space: nowrap;
}
.auditModel {
  width: 60%;
  margin: 0 auto;
  .el-input,
  .el-textarea {
    display: inline-block;
    width: 300px;
  }
  .formItemRemark {
    font-size: 12px;
    // width:700px;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 12px;
    padding-right: 12px;
  }
  .el-date-editor .el-input__prefix {
    left: auto;
    right: 5px;
  }
  .imgsArea {
    display: flex;
    flex-wrap: wrap;

    .image {
      width: 100px;
      flex-shrink: 0;
      margin-right: 10px;
    }
  }
  .imgFile {
    // width: 100px;

    margin-right: 15px;
    display: flex;
    .image {
      width: 100px;
      height: 100px;
      margin: 10px;
    }
    img {
      width: 100px;
      height: 100px;
      cursor: pointer;
    }
    .file-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      flex-wrap: wrap;
    }
    // span {
    //   white-space: nowrap;
    // }
    .cursor {
      position: absolute;
      top: 0;
      right: 5px;
      display: inline-block;
    }
  }
}
</style>
